import apiClient from '../server';

// Get all organizer accounts with Stripe Connect status
export const fetchOrganizerAccounts = async () => {
  const response = await apiClient.get('/organizer-accounts');
  return response.data;
};

// Get single organizer account details
export const fetchOrganizerAccount = async (accountId) => {
  const response = await apiClient.get(`/organizer-accounts/${accountId}`);
  return response.data;
};

// Refresh organizer's Stripe status
export const refreshStripeStatus = async (accountId) => {
  const response = await apiClient.post(`/organizer-accounts/${accountId}/stripe-status`);
  return response.data;
};

// Get all pending payouts across all organizers
export const fetchPendingPayouts = async () => {
  const response = await apiClient.get('/payments/payout/pending');
  return response.data;
};

// Get event payout summary
export const fetchEventPayoutSummary = async (eventId) => {
  const response = await apiClient.get(`/payments/payout/event/${eventId}`);
  return response.data;
};

// Transfer funds to organizer (release payout)
export const transferToOrganizer = async (data) => {
  const response = await apiClient.post('/payments/payout/transfer', data);
  return response.data;
};

// Cancel a pending payout
export const cancelPayout = async (data) => {
  const response = await apiClient.post('/payments/payout/cancel', data);
  return response.data;
};

// Get payout history
export const fetchPayoutHistory = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.eventId) queryParams.append('eventId', params.eventId);
  if (params.organizerId) queryParams.append('organizerId', params.organizerId);
  if (params.status) queryParams.append('status', params.status);
  if (params.limit) queryParams.append('limit', params.limit);

  const queryString = queryParams.toString();
  const url = `/payments/payout/history${queryString ? `?${queryString}` : ''}`;
  const response = await apiClient.get(url);
  return response.data;
};

// Payout status colors
export const PAYOUT_STATUS_COLORS = {
  'pending': 'orange',
  'partial': 'blue',
  'completed': 'green',
  'Completed': 'green',
  'Pending': 'orange',
  'Failed': 'red',
  'Reversed': 'purple',
  'cancelled': 'red',
};

// Stripe status colors
export const STRIPE_STATUS_COLORS = {
  'Active': 'green',
  'Pending': 'gold',
  'Not Started': 'default',
  'Restricted': 'orange',
  'Suspended': 'red',
};

// Format currency
export const formatCurrency = (amount, currency = 'CAD') => {
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: currency,
  }).format(amount || 0);
};

// Calculate days since event
export const daysSinceEvent = (eventEndTime) => {
  if (!eventEndTime) return null;
  const now = new Date();
  const endDate = new Date(eventEndTime);
  const diffTime = now - endDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};
